export enum TipoMenu {
  ICONOS = 'ICONOS',
  STEPPER = 'STEPPER',
}
